import { render, staticRenderFns } from "./CosmicBackground.vue?vue&type=template&id=16ec7a3f&scoped=true"
import script from "./CosmicBackground.vue?vue&type=script&lang=js"
export * from "./CosmicBackground.vue?vue&type=script&lang=js"
import style0 from "./CosmicBackground.vue?vue&type=style&index=0&id=16ec7a3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ec7a3f",
  null
  
)

export default component.exports